import Filter from "~/pages/round/RoundReg/components/Filter";
import ModalTemplate from "~/common/components/ModalPortal/ModalTemplate";
import React, { useEffect, useState } from "react";
import { API_STATE } from "~/common/constants/state";
import useRequest from "~/common/hooks/useRequest";
import { CautionIcon } from "~/assets/svg/InterfaceIcon";
import { dateToString } from "~/utils/formatter";
import useAlert from "~/common/hooks/useAlert";
import { useTranslation } from "react-i18next";
import company from "~/pages/DashboardPage/Company";

const CompanySelectModal = ({
	selectCompanyModal,
	setSelectCompanyModal,
	companyList,
	setCompanyList,
	options,
}) => {
	const { t } = useTranslation();
	const [showErrorAlert, ErrorAlert] = useAlert();

	const [corpData, setCorpData] = useState([]);
	const [formData, setFormData] = useState({
		industry: [],
		minComValue: "",
		maxComValue: "",
		name: "",
	});

	const companyListRequest = useRequest("post", "vc/round/search/startup/company");

	const callCompany = () => {
		companyListRequest.call(
			{
				...formData,
				minComValue: formData.minComValue !== "" ? formData.minComValue * 100000000 : "",
				maxComValue: formData.maxComValue !== "" ? formData.maxComValue * 100000000 : "",
			},
			"body"
		);
	};

	useEffect(() => {
		// setCompanyList((prevState) => prevState.filter((p) => p.checked === true));
		callCompany();
	}, [formData]);

	useEffect(() => {
		if (selectCompanyModal) {
			setFormData({
				industry: [],
				minComValue: "",
				maxComValue: "",
				name: "",
			});
		}
	}, [selectCompanyModal]);

	useEffect(() => {
		switch (companyListRequest.state) {
			case API_STATE.done:
				const addList = [...companyList, ...companyListRequest.response.companyList];

				const addCheckedCompanyList = addList.reduce((acc, current) => {
					if (!!current.checked) {
						acc.push(current);
					}
					if (acc.findIndex(({ idx }) => idx === current.idx) === -1) {
						acc.push({ ...current, checked: false });
					}
					return acc;
				}, []);

				// @INFO 정렬 로직 추가
				// 1. 기업, 대표자이름, 설립일자, 산업분야 모두 기입된 기업
				// 2. 기업, 대표자이름, 산업분야 기입된 기업
				// 3. 기업, 대표자이름, 설립일자 기입된 기업
				// 4. 기업, 대표자이름 기입된 기업
				// 5. 기업명만 기입된 기업
				// 6. 아무것도 기입되지 않은 기업

				const getPriority = (item) => {
					const { name, ceoName, CompanyField, estDate } = item;
					if (name && ceoName && CompanyField.length > 0 && estDate) return 1;
					if (name && ceoName && CompanyField.length > 0) return 2;
					if (name && ceoName && estDate) return 3;
					if (name && ceoName) return 4;
					if (name && name !== '-') return 5;
					if ((!name || name === '-') && !ceoName && CompanyField.length === 0 && !estDate) return 6;
					return 7; // Default case, if it doesn't match any of the above criteria
				}

				const sortedData = addCheckedCompanyList.sort((a, b) => getPriority(a) - getPriority(b));

				setCorpData(sortedData);
				// setCompanyList(addCheckedCompanyList);
				break;
			default:
				break;
		}
	}, [companyListRequest.state, companyListRequest.response]);

	const handleChangeIndustry = (data) => {
		setFormData({
			...formData,
			industry: data,
		});
	};

	const handleChangeComValue = (min, max) => {
		if (min > max) {
			showErrorAlert();
			return;
		}

		setFormData({
			...formData,
			minComValue: min,
			maxComValue: max,
		});
	};

	const handleChangeName = (data) => {
		setFormData({
			...formData,
			name: data,
		});
	};

	const saveCompany = () => {
		setCompanyList(corpData);
		setSelectCompanyModal(false);
	};

	const checkCompany = (checkCompany) => {
		const checkedCompanyList = corpData;
		const checkedIndex = corpData.findIndex((company) => company.idx === checkCompany.idx);
		checkedCompanyList[checkedIndex].checked = !checkedCompanyList[checkedIndex].checked;

		// checkedCompanyList.sort((a, b) => b.idx - a.idx);
		setCorpData([...checkedCompanyList]);
	};

	const checkAll = () => {
		let allCompanyList = corpData;

		if (allCompanyList.every((company) => company.checked === true)) {
			allCompanyList = allCompanyList.map((company) => {
				return { ...company, checked: false };
			});
		} else {
			allCompanyList = allCompanyList.map((company) => {
				return { ...company, checked: true };
			});
		}

		setCorpData([...allCompanyList]);
	};


	return (
		<ModalTemplate
			title={t("pages.round.RoundReg.components.CompanySelectModal.title")}
			modalState={selectCompanyModal}
			setModalToggle={setSelectCompanyModal}
			width={960}
			heigth={967}
			className="round-company-modal"
		>
			<div className="round-company-select-modal active">
				<Filter
					formData={formData}
					roundToggle={false}
					industryOptions={options}
					onChangeName={handleChangeName}
					onChangeIndustry={handleChangeIndustry}
					onChangeComValue={handleChangeComValue}
				/>
				{/* <p className="warning-phrase">
					※ 아래 기업 리스트는 깃발 ST에서 기업 & 제품 정보를 모두 입력한 기업입니다. 기업
					& 제품 정보를 미입력한 기업은 리스트에서 확인이 불가합니다.
				</p> */}
			</div>

			<div className="c__table">
				<div className="thead">
					<div className="tr">
						<label className="th company-name checkbox-custom">
							<input
								type="checkbox"
								checked={
									corpData.length > 0 &&
									corpData.every((company) => company?.checked === true)
								}
								onChange={checkAll}
							/>
							<span className="checkmark" />
							<span className="checkbox-label">
								{t(
									"pages.round.RoundReg.components.CompanySelectModal.company-name"
								)}
							</span>
						</label>
						<div className="th company-wrap">
							{t("pages.round.RoundReg.components.CompanySelectModal.company-ceo")}
						</div>
						<div className="th company-info">
							{t("pages.round.RoundReg.components.CompanySelectModal.estDate")}
						</div>
						<div className="th company-product">
							{t("pages.round.RoundReg.components.CompanySelectModal.industry")}
						</div>
					</div>
				</div>
				<div className="tbody">

					{corpData.map((company, idx) => (
						<div
							className={"tr favorite"}
							onClick={(e) => {
								e.preventDefault();
								checkCompany(company);
							}}
							key={company.idx}
						>
							<label className="td company-name checkbox-custom">
								<input
									type="checkbox"
									checked={company.checked}
								/>
								<span className="checkmark" />
								<span className="checkbox-label">{company.name}</span>
							</label>
							<div className="td company-wrap">
								<div className="company-ceo">{company.ceoName}</div>
							</div>
							<div className="td company-info">
								{dateToString(company.estDate, "yyyy-MM-dd")}
							</div>
							<div className="td company-tag">
								{company.CompanyField?.map((industry) => (
									<span key={industry.idx}>{industry.field}</span>
								))}
							</div>
						</div>
					))}
					{corpData.length < 1 && (
						<div className="c__noData">
							<CautionIcon />
							<p className="main">
								{t("pages.round.RoundReg.components.CompanySelectModal.noData")}
							</p>
						</div>
					)}
				</div>
			</div>
			<div className="modal-footer">
				<button
					className="btn__solid"
					color="gray"
					onClick={() => {
						setCorpData([]);
						setSelectCompanyModal(false);
					}}
				>
					{t("pages.round.RoundReg.components.CompanySelectModal.cancel")}
				</button>
				<button className="btn__solid" color="primary" onClick={saveCompany}>
					{t("pages.round.RoundReg.components.CompanySelectModal.confirm")}
				</button>
			</div>
			<ErrorAlert
				message={t("pages.round.RoundReg.components.CompanySelectModal.ErrorAlert")}
				type="error"
				confirm={t("pages.round.RoundReg.components.CompanySelectModal.confirm")}
			/>
		</ModalTemplate>
	);
};

export default CompanySelectModal;
